import { render, staticRenderFns } from "./OrderFood.vue?vue&type=template&id=76d32e4c&scoped=true"
import script from "./OrderFood.vue?vue&type=script&lang=js"
export * from "./OrderFood.vue?vue&type=script&lang=js"
import style0 from "./OrderFood.vue?vue&type=style&index=0&id=76d32e4c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76d32e4c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Untitled/project/050/050admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('76d32e4c')) {
      api.createRecord('76d32e4c', component.options)
    } else {
      api.reload('76d32e4c', component.options)
    }
    module.hot.accept("./OrderFood.vue?vue&type=template&id=76d32e4c&scoped=true", function () {
      api.rerender('76d32e4c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customer/components/OrderFood.vue"
export default component.exports